// extracted by mini-css-extract-plugin
export default {"operationPanelPosition":"r62Hyz"};